

module.exports = require('./Validation');



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/